import { rgba } from 'polished';
import { Box } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Box)<{
	progress: number;
}>`
	width: 32px;
	height: 32px;
	padding: 4px;
	border-radius: 16px;
	background: ${(props) => `conic-gradient(
		${props.theme.colors.employee} 0deg,
		${props.theme.colors.employee} ${(props.progress * 360).toFixed()}deg,
		${rgba(props.theme.colors.employee, 0.15)} ${(props.progress * 360).toFixed()}deg
	)`};
`;

const Text = styled(Box)`
	width: 24px;
	height: 24px;
	border-radius: 12px;
	background: white;
	text-align: center;
	line-height: 24px;
	font-weight: bold;
	font-size: 10px;
`;

export default function TalentReviewProgressPie(props: { progress: number }) {
	return (
		<Container progress={props.progress}>
			<Text>{(props.progress * 100).toFixed()}%</Text>
		</Container>
	);
}
